module.exports = __webpack_public_path__ + "static/img/dialog_1.ecf41c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/guide/dialog_1.png
// module id = nwQp
// module chunks = 4